(($, Drupal) => {
  Drupal.behaviors.userWidget = {
    attach: (context) => {
      if ($(context).hasClass("js-user-widget")) {
        $(document).on("click", (e) => {
          if (!$(e.target).is(".js-user-widget-picture")) {
            const $userWidget = $(".js-user-widget");
            if ($userWidget.hasClass("is-visible")) {
              $userWidget.removeClass("is-visible");
            }
          }
        });

        $(".js-user-widget-picture", context).on("click", () => {
          $(".js-user-widget").toggleClass("is-visible");
        });
      }
    },
  };
})(jQuery, Drupal);
